import { SignPost } from "./components/SignPost/SignPost";

type Props = {
  /**
   * A string representing the title.
   */
  title: string;
};

export const BundleSignPostUI = ({ title }: Props) => {
  return <SignPost title={title} />;
};
